<form #formResetPassword="ngForm" id="enterPassword" name="formResetPassword" (submit)="handleSubmitResetPassword(formResetPassword.value, $event)" novalidate>
  <h3 class="text-dark-blue">{{ appCopy.panelHeader['title'+selectedLanguage] }}</h3>
  <p class="text-dark-blue">{{ appCopy.panelHeader['titleDescription'+selectedLanguage] }}</p>
  <div class="form-group">
    <input class="form-control" 
            [ngClass]="{ 'has-error' : Password.invalid && Password.dirty }"
            id="Password" 
            name="Password" 
            type="password"
            #Password="ngModel"
            [(ngModel)]="passwordValues.password1"
            ngModel
            required
            appCheckEmpty>
    <label class="control-label" for="Password">{{ appCopy.panelHeader['loginPasswordLabel'+selectedLanguage] }}</label>
    <i class="icon control-validation-state"></i>
    
    <p class="help-block text-danger" *ngIf="Password.invalid && Password.dirty">{{ appCopy.panelHeader['warningEnterPassword'+selectedLanguage] }}</p>
  </div>

  <div class="form-group">
    <input class="form-control" 
            [ngClass]="{ 'has-error' : PasswordVerify.invalid && PasswordVerify.dirty || !passwordMatch }"
            id="PasswordVerify" 
            name="PasswordVerify" 
            type="password"
            #PasswordVerify="ngModel"
            [(ngModel)]="passwordValues.password2"
            (ngModelChange)="passwordsEqual()"
            ngModel
            required
            appCheckEmpty>
    <label class="control-label" for="PasswordVerify">{{ appCopy.panelHeader['loginRePasswordLabel'+selectedLanguage] }}</label>
    <i class="icon control-validation-state"></i>
    
    <p class="help-block text-danger" *ngIf="PasswordVerify.invalid && PasswordVerify.dirty">{{ appCopy.panelHeader['warningReEnterPassword'+selectedLanguage] }}</p>
    <p class="help-block text-danger" *ngIf="!passwordMatch">{{ appCopy.panelHeader['warningMatchPassword'+selectedLanguage] }}</p>
  </div>

  <button type="submit" class="btn btn-purple btn-lg btn-block" [disabled]="formResetPassword.invalid || showLoader">
    <div class="loader-container-btn" *ngIf="showLoader">
      <div class="loader loader--white">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
    {{ appCopy.panelHeader['btnSetPassword'+selectedLanguage] }}
  </button>

</form>